<template src="./Add.html">
</template>

<script>
    import { showAlert } from "@/utils/helpers";

    export default {
        created() {
            this.$store.dispatch("lookups/getVacationTypes");

        },
        computed: {
            vacationsTypes() {
                return this.$store.state.lookups.vacationTypes;

            },

        },
        data() {
            return {
                balance:null,
                leave: {
                    description: null,
                    startDate: null,
                    endDate: null,
                    officialHoliday: null,
                    hasOffical: false,
                },
            };
        },
        methods: {
            checkDate() {
                if (this.leave.startDate > this.leave.endDate) {
                    showAlert("يجب ان يكون تاريخ بداية الاجازة اقل من تاريخ نهايتها");
                    this.leave.endDate=null
                    return;

                }
            },
            getVacationsBalance() {
                if (this.leave.vacationTypeId == 1) {
                
                    this.$store.dispatch("leaves/getVacationsBalance").then((res) => {
                        this.balance = res.balance.duration;
                        this.leave.employeeVacationBalanceId = res.balance.employeeVacationBalanceId;
                    })
                        .catch(() => { });
                }

            },
       
            confirm() {

                this.$store
                    .dispatch("leaves/add", this.leave)
                    .then(() => {
                        this.back();
                    })
                    .catch(() => { });
            },

            back() {
                this.$emit("back");
            },
        },
    };
</script>